import { render, staticRenderFns } from "./NoteCard.vue?vue&type=template&id=29f20d1a&scoped=true&"
import script from "./NoteCard.vue?vue&type=script&lang=js&"
export * from "./NoteCard.vue?vue&type=script&lang=js&"
import style0 from "./NoteCard.vue?vue&type=style&index=0&id=29f20d1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f20d1a",
  null
  
)

export default component.exports